/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { teamBulkCreateItemRequestSchema } from './teamBulkCreateItemRequestSchema';

export const teamBulkCreateRequestSchema = z.object({
  loopId: z.int().nullish(),
  get teams() {
    return z.array(teamBulkCreateItemRequestSchema).min(0).max(100);
  },
});
